import { Link } from "@yardzen/ui/components/link";
import ReactMarkdown from "react-markdown";

/** Markdown from a Contentful long-text field: paragraphs and links. */
export function MarkdownText({ children }: { children: string }) {
  return (
    <ReactMarkdown
      components={{
        a: ({ href, children }) => (
          <Link href={href ?? "#"} className="underline">
            {children}
          </Link>
        ),
        p: ({ children }) => <p className="mb-3 last:mb-0">{children}</p>,
      }}
    >
      {children}
    </ReactMarkdown>
  );
}
